import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  User,
  Calculator,
  Mail,
  Trash2,
  LogOut,
  ChevronRight,
} from "lucide-react";
import { useHistory } from "react-router-dom";
import BossSettingUpdateModal from "./BossSettingComps/BossSettingUpdateModal";
import BossSettingHeader from "./BossSettingComps/BossSettingHeader";

const menuItems = [
  {
    id: "accountant",
    titleKey: "accountant",
    Icon: Calculator,
    route: "/BossSettingAccountant",
    color: "#06b6d4",
  },
  {
    id: "contact",
    titleKey: "contactUs",
    Icon: Mail,
    route: "/ContactUs",
    color: "#10b981",
  },
  {
    id: "delete",
    titleKey: "deleteAccount",
    Icon: Trash2,
    action: "delete",
    color: "#ef4444",
  },
  {
    id: "logout",
    titleKey: "logout",
    Icon: LogOut,
    action: "logout",
    color: "#f59e0b",
  },
];

export default function BossSetting() {
  const { t } = useTranslation();
  const history = useHistory();
  const [userData, setUserData] = useState(null);
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) setUserData(JSON.parse(user));
  }, []);

  // ── Logout ────────────────────────────────────────────────────────────────
  const handleLogOut = () => {
    if (!window.confirm(t("confirmLogout"))) return;
    localStorage.removeItem("user");
    localStorage.removeItem("allData");
    history.replace("/Login");
  };

  // ── Delete account ────────────────────────────────────────────────────────
  const handleDeleteAccount = () => {
    if (
      !window.confirm(t("deleteAccountMessage"))
    )
      return;
    localStorage.removeItem("user");
    localStorage.removeItem("allData");
    history.replace("/Login");
  };

  const handleItemPress = (item) => {
    if (item.action === "logout") {
      handleLogOut();
    } else if (item.action === "delete") {
      handleDeleteAccount();
    } else if (item.route) {
      history.push(item.route);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-2xl mx-auto pb-8">
        {/* ── Settings header component ── */}
        <BossSettingHeader />

        {/* ── User info card ── */}
        <div className="px-4 mt-4">
          <button
            onClick={() => setShowUpdateModal(true)}
            className="w-full bg-white rounded-2xl px-4 py-4 shadow-sm flex items-center gap-3 hover:shadow-md transition text-left"
          >
            <div className="w-10 h-10 bg-sky-100 rounded-full flex items-center justify-center flex-shrink-0">
              <User className="w-5 h-5 text-sky-500" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-slate-500 font-medium mb-0.5">{t("name")}</p>
              <p className="text-base font-semibold text-slate-800 truncate">
                {userData?.name || "—"}
              </p>
            </div>
            <ChevronRight className="w-5 h-5 text-slate-300 flex-shrink-0" />
          </button>
        </div>

        {/* ── Menu items ── */}
        <div className="px-4 mt-6">
          <h2 className="text-lg font-bold text-slate-800 mb-3 ml-1">
            {t("settings")}
          </h2>

          <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
            {menuItems.map((item, index) => {
              const { Icon } = item;
              return (
                <button
                  key={item.id}
                  onClick={() => handleItemPress(item)}
                  className={`w-full flex items-center gap-3 px-4 py-4 hover:bg-gray-50 transition text-left ${
                    index !== 0 ? "border-t border-slate-100" : ""
                  }`}
                >
                  <div
                    className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: `${item.color}18` }}
                  >
                    <Icon className="w-5 h-5" style={{ color: item.color }} />
                  </div>
                  <p className="flex-1 text-base font-medium text-slate-800">
                    {t(item.titleKey)}
                  </p>
                  <ChevronRight className="w-5 h-5 text-slate-300 flex-shrink-0" />
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* ── Update modal ── */}
      <BossSettingUpdateModal
        visible={showUpdateModal}
        onClose={() => setShowUpdateModal(false)}
      />
    </div>
  );
}
